import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import GlobalTradingNetwork from "@/components/GlobalTradingNetwork";
import ProductCategories from "@/components/ProductCategories";
import WhyOmniCoreTek from "@/components/WhyOmniCoreTek";
import IndustriesServed from "@/components/IndustriesServed";
import PartnerMarquee from "@/components/PartnerMarquee";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import SectionTransition from "@/components/SectionTransition";

export default function Landing() {
  return (
    <div className="relative" data-testid="landing-page">
      <Nav />
      <main className="relative z-10">
        <Hero />
        <SectionTransition label="Entering the network" />
        <GlobalTradingNetwork />
        <SectionTransition label="Route → Catalog" />
        <ProductCategories />
        <SectionTransition label="Operating principles" />
        <WhyOmniCoreTek />
        <SectionTransition label="Downstream · Buyers" />
        <IndustriesServed />
        <SectionTransition label="Upstream · Authorized" />
        <PartnerMarquee />
        <SectionTransition label="Terminal · Desk" />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
